import { NAICS_2022 } from '../data/naics-2022.ts';

export type Naics2022Option = (typeof NAICS_2022)[number];

const NAICS_2022_BY_CODE = new Map(NAICS_2022.map((option) => [option.code, option]));

export function naics2022Option(code: string): Naics2022Option | null {
  return NAICS_2022_BY_CODE.get(code.trim()) ?? null;
}

export function isNaics2022Code(code: string): boolean {
  return NAICS_2022_BY_CODE.has(code.trim());
}

export { NAICS_2022 };
